import { FC, MouseEventHandler } from 'react';
import styles from './listing-card.module.css';

export interface ListingCardProps {
  title: string;
  subtitle: string;
  category?: string;
  rating?: number;
  focused?: boolean;
  isFavourite?: boolean;
  isDigital?: boolean;
  cost?: string;
  type?: 'online' | 'in-person';
  disposition?: 'line' | 'card';
  department?: string;
  onClick: MouseEventHandler;
  onClickFavourite: MouseEventHandler;
  onClickOnlineService: MouseEventHandler;
  href: string;
}

export const ListingCard: FC<ListingCardProps> = ({
  title,
  subtitle,
  category,
  rating,
  type,
  isDigital,
  cost,
  department,
  onClick,
  onClickFavourite,
  onClickOnlineService,
  href,
}) => {
  return (
    <div className={styles.card}>
      <div>
        <div className={styles.category}>{category}</div>
        <div className={styles.title}>{title}</div>
      </div>

      <div className={styles.footer}>
        <a
          className={styles.moreInfo}
          href={href}
          onClick={(e) => {
            if (
              e.button !== 0 || 
              e.metaKey ||
              e.ctrlKey ||
              e.shiftKey ||
              e.altKey
            ) {
              return;
            }
            e.preventDefault();
            onClick(e); 
          }}
        >
          Mais Informações
        </a>

        {isDigital && (
          <button className={styles.button} onClick={onClickOnlineService}>
            Solicitar
          </button>
        )}
      </div>
    </div>
  );
};